// extracted by mini-css-extract-plugin
module.exports = {"mansoryCardFanz":"Fanz_mansoryCardFanz__L7JkH"};